module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4z0do"))).then(() => parcelRequire('1iHdE'));